import { AuthState } from "@okta/okta-auth-js";
import { Server } from "../../Shared/Util/Server";
import { formatRequestParams } from "./RequestFormatting";

export interface IPublishedRequestParams {
  pageNumber: number;
  pageSize: number;
  skip: number;
  filter: { filters: any[] };
  orderBy: string;
}

export function fetchResponses(auth: AuthState, requestParams: IPublishedRequestParams): Promise<Api.IResponseListResponse | null> {
  const updatedParams = formatRequestParams(requestParams);

  let url = `/v1/response?pageNumber=${updatedParams.pageNumber}&resultsPerPage=${updatedParams.pageSize}&orderBy=${updatedParams.orderBy}`;
  if (updatedParams.filter.filters) {
    url += `&filter=${updatedParams.filter.filters}`;
  }
  return Server.get<Api.IResponseListResponse>(url, auth);
}

export function fetchResponseVersions(responseId: string, auth: AuthState): Promise<Api.IHistoricalResponseListViewModel | null> {
  return Server.get<Api.IHistoricalResponseListViewModel>(`/response/${responseId}/versions`, auth);
}

export function fetchResponsesFacet(auth: AuthState, propertyName: string): Promise<Api.IResponseListResponse | null> {
  return Server.get<Api.IResponseListResponse>(`/v1/response?pageNumber=1&resultsPerPage=1&orderBy=dateModified desc&facet=${propertyName},count:200`, auth);
}
